import color from "../../../constants/color";

const styles = {
  card: {
    borderRadius: "12px",
    padding: "16px",
    backgroundColor: "#fff",
    boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    minHeight: "260px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
  },
  headerIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: "#F0F9F4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: "16px",
    color: "#202020",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 12px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#F9F9F9",
    },
  },
  menuItemActive: {
    backgroundColor: "#F5F7F9",
  },
  menuText: {
    fontSize: "14px",
  },
  chevronIcon: {
    fontSize: "18px",
    color: "#28AA4A",
  },
  container: {
    height: '300px',
    padding: '20px',
    borderRadius: '8px',
    margin: '20px',
  },
  filterSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '1',
    marginRight: '16px',
  },
  searchInput: {
    width: "208.03px", // Rounded to 2 decimals
    height: "30px",
    opacity: 1,
    borderRadius: "40px",
    paddingTop: "6px",
    paddingRight: "10px",
    paddingBottom: "6px",
    paddingLeft: "10px",
    gap: "3px",
    background: "#F1F1F1",
    border: "none",           // Optional: clean border
    outline: "none",          // Optional: remove blue outline on focus
  },
  formSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    marginBottom: '24px',
  },
}
export default styles; 